// Update values in service worker (image-loading-tracking.js) accordingly!
export const ImagePerformanceQueryParamKey = 'logperformance';
export const ImagePerformanceQueryParamValue = '1';
